import type { LocationMatch } from '@citibox-panel/api-client';
import { useDebouncedSearch, type UseDebouncedSearch } from '../../../lib/useDebouncedSearch';
import { locationSearchKey } from '../../../lib/locationSearchKey';

export type UseLocationSearch = UseDebouncedSearch<LocationMatch[]>;

// A thin layer over `useDebouncedSearch`: this hook owns WHAT is searched and under which key, and
// nothing about the debounce, the floor or the settled-term bookkeeping — all of which moved to
// `care/src/lib` so the ficha's address field could reuse them instead of growing a second copy.
export function useLocationSearch(
  query: string,
  searchLocations: (q: string) => Promise<LocationMatch[]>,
): UseLocationSearch {
  return useDebouncedSearch({
    query,
    queryKey: locationSearchKey,
    search: searchLocations,
  });
}
